import * as React from "react";
import { Button, Dropdown, Menu, Icon, Select } from "antd";
const Option = Select.Option;
import { EUrl, transformUrl } from "utils/enum/url";
import OrderStatistics from "widget/orderButtonGroup/orderStatistics";

import {
  SynchTmallNo,
  SecondaryConfirm,
  SendGoods,
  Signs,
  Modify,
  Mergelist,
  Additionalist,
  SecondaryCheck,
  AfterSale,
  AllocationOrder,
  ExportExcel,
  Unsubscribel,
  Nounsubscribel,
  Verify,
} from "widget/orderButtonGroup";

// form中包含的组件类型
enum EButtonType {
  default = 0,
  dropdown = 1,
  buttonSelect = 2,
  // 同步淘宝订单
  synchTmallNo = 3,
  // 二次确认
  secondaryConfirm = 4,
  // 批量发货
  sendGoods = 5,
  // 批量签名
  signs = 6,
  // 批量二次检查
  secondaryCheck = 7,
  // 批量售后
  afterSale = 8,
  // 分配订单
  allocationOrder = 9,
  // 导出Excel
  exportExcel = 10,
  // 新增订单
  addOrder = 11,
  // 订单统计数据
  orderStatis = 12,
  //预定审核
  verify = 13,
  //修改
  modify = 14,
  //退订
  unsubscribe = 15,
  //合并订单
  merge = 16,
  //附加项目
  additional = 17,
  //取消退订
  cancel_unsubscribe = 18,
  //修改审核
  modify_audit = 19,
  //无需供应商
  supplier_auto = 20

}

interface IButtonData {
  // 标题
  label: string;
  onClick?: any;
  // 组件类型
  type: EButtonType;
  style?: any;
  // 扩展字段
  extField1?: any;
  extField2?: any;
}

interface IButtonGroupProps {
  buttonGroup: IButtonData[];
}

const getInfo = buttonGroup => {
  let buttonList: any = [];

  for (const item of buttonGroup) {
    switch (item.type) {
      case EButtonType.addOrder:
        const menu = (
          <Menu>
            <Menu.Item key="1">
              <a href={transformUrl(EUrl.addOrder)} target="_blank">
                新增单个订单
              </a>
            </Menu.Item>
            <Menu.Item key="2">
              <a href={transformUrl(EUrl.importOrderMFW)} target="_blank">
                批量导入订单 (马蜂窝)
              </a>
            </Menu.Item>
            <Menu.Item key="3">
              {" "}
              <a href={transformUrl(EUrl.importOrderXC)} target="_blank">
                批量导入订单（携程）
              </a>
            </Menu.Item>
            <Menu.Item key="3">
              {" "}
              <a href={transformUrl(EUrl.importOrderQNR)} target="_blank">
                批量导入订单(去哪儿)
              </a>
            </Menu.Item>
            <Menu.Item key="1">
              <a href={EUrl.addCustomOrder} target="_blank">
                新增定制单
              </a>
            </Menu.Item>
          </Menu>
        );
        const buttonStyle = {
          backgroundColor: "#2b9fbd",
          borderColor: "#2b9fbd"
        };
        buttonList.push(
          <Dropdown overlay={menu} key={item.label}>
            <Button type="primary" style={buttonStyle}>
              {item.label} <Icon type="down" />
            </Button>
          </Dropdown>
        );
        break;
      case EButtonType.buttonSelect:
        buttonList.push(
          <Button.Group
            size="default"
            className="button-select"
            key={item.label}
          >
            <Select
              key={item.label}
              placeholder="请选择客服"
              allowClear
              size="default"
              style={{ width: 110 }}
            >
              <Option value="欧阳娜娜">欧阳娜娜</Option>
              <Option value="刘小琴">刘小琴</Option>
              <Option value="西施">西施</Option>
              <Option value="天雅">天雅</Option>
            </Select>
            <Button type="primary">分配订单</Button>
          </Button.Group>
        );
        break;
      case EButtonType.synchTmallNo:
        // 同步淘宝订单
        buttonList.push(
          <SynchTmallNo key={item.label} searchOrder={item.extField1} />
        );
        break;
      case EButtonType.secondaryConfirm:
        buttonList.push(
          <SecondaryConfirm
            orderNo={item.extField1}
            searchOrder={item.extField2}
            key={item.label}
          />
        );
        break;
      case EButtonType.sendGoods:
        buttonList.push(
          <SendGoods
            orderNo={item.extField1}
            searchOrder={item.extField2}
            key={item.label}
          />
        );
        break;
      case EButtonType.signs:
        buttonList.push(
          <Signs
            orderNo={item.extField1}
            searchOrder={item.extField2}
            key={item.label}
          />
        );
        break;
      case EButtonType.secondaryCheck:
        buttonList.push(
          <SecondaryCheck
            orderNo={item.extField1}
            searchOrder={item.extField2}
            key={item.label}
          />
        );
        break;
      case EButtonType.afterSale:
        buttonList.push(
          <AfterSale
            orderNo={item.extField1}
            searchOrder={item.extField2}
            key={item.label}
          />
        );
        break;
      case EButtonType.allocationOrder:
        buttonList.push(
          <AllocationOrder
            orderNo={item.extField1}
            searchOrder={item.extField2}
            key={item.label}
          />
        );
        break;
      case EButtonType.exportExcel:
        buttonList.push(
          <ExportExcel key={item.label} formParam={item.extField1} />
        );
        break;
      // 订单统计
      case EButtonType.orderStatis:
        buttonList.push(
          <OrderStatistics
            key={item.label}
            formParam={item.extField1}
            orderTotal={item.extField2}
          />
        );
        break;
      case EButtonType.default:
        buttonList.push(
          <Button
            type="primary"
            key={item.label}
            style={{ ...item.style, padding: "0", backgroundColor: "#2b9fbd" }}
          >
            <div>{item.label}</div>
          </Button>
        );
      case 14:
        buttonList.push(
          <Modify
            style={item.style}
            label={item.label}
          />
        );
        break;
      case 15:
        buttonList.push(
          <Unsubscribel style={item.style} label={item.label} />
        );
        break;
      case 13:
        buttonList.push(
          <Verify style={item.style} label={item.label} />
        );
        break;
      case 18:
        buttonList.push(
          <Nounsubscribel style={item.style} label={item.label} />
        );
        break;
      case 16:
        buttonList.push(
          <Mergelist
            style={item.style}
            label={item.label}
          />
        );
        break;
      case 17:
        buttonList.push(
          <Additionalist
            style={item.style}
            label={item.label}
          />
        );
        break;
      default:
        buttonList.push(
          <Button
            type="primary"
            key={item.label}
            style={{ ...item.style, paddingLeft: "28", paddingRight: "28", backgroundColor: "#2b9fbd" }}
          >
            <div>{item.label}</div>
          </Button>
        );
        break;
    }
  }

  return buttonList;
};

// 按钮组
class ButtonGroup extends React.Component<IButtonGroupProps, any> {
  constructor(props: IButtonGroupProps) {
    super(props);

    // this.state = {
    //   buttonGroup: getInfo(this.props.buttonGroup)
    // };
    // this.setState({
    //   buttonGroup: buttonList
    // });
  }

  render() {
    const buttonGroup = getInfo(this.props.buttonGroup);
    return <div className="button-group">{buttonGroup}</div>;
  }
}

export default ButtonGroup;
